"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aquamarine = '#25B0C0';
exports.almostWhite = '#FBFBFB';
exports.beige = '#FFFEF4';
exports.black = '#000000';
exports.charcoal = '#323232';
exports.cloud = '#EEEEEE';
exports.foam = '#95E1EA';
exports.graphite = '#5D5D5D';
exports.green = '#34CBB3';
exports.mercury = '#E9E9E9';
exports.palefoam = '#F2FCFD';
exports.palegreen = '#E6FAF7';
exports.palered = '#FEF1EB';
exports.paleyellow = '#FDF7ED';
exports.quartz = '#F5F5F5';
exports.red = '#E37A48';
exports.silver = '#BCBCBC';
exports.steel = '#818181';
exports.titanium = '#D8D8D8';
exports.turquoise = '#2AC5D6';
exports.white = '#FFFFFF';
exports.yellow = '#E7B158';
